import { render, staticRenderFns } from "./registered-form.vue?vue&type=template&id=4c577264&scoped=true"
import script from "./registered-form.vue?vue&type=script&lang=js"
export * from "./registered-form.vue?vue&type=script&lang=js"
import style0 from "./registered-form.vue?vue&type=style&index=0&id=4c577264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c577264",
  null
  
)

export default component.exports